function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { generateStripe, getColor, mode } from '../../theme-tools';
import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['track', 'filledTrack', 'panel'];
function filledStyle(props) {
  var {
    colorScheme: bgColor,
    theme: t,
    isIndeterminate,
    hasStripe
  } = props;
  var stripeStyle = mode(generateStripe(), generateStripe('1rem', 'rgba(0,0,0,0.1)'))(props);
  var gradient = "linear-gradient(\n    to right,\n    transparent 0%,\n    ".concat(getColor(t, bgColor), " 50%,\n    transparent 100%\n  )");
  var addStripe = !isIndeterminate && hasStripe;
  return _objectSpread(_objectSpread({}, addStripe && stripeStyle), isIndeterminate ? {
    bgImage: gradient
  } : {
    bgColor
  });
}
var baseStyleTrack = {
  bg: 'grey.250',
  borderRadius: 1
};
function baseStyleFilledTrack(props) {
  return _objectSpread({
    transition: 'all 0.3s'
  }, filledStyle(props));
}
var baseStyle = props => ({
  filledTrack: baseStyleFilledTrack(props),
  track: baseStyleTrack
});
var sizes = {
  xs: {
    track: {
      h: 1,
      borderRadius: '0.125rem'
    }
  },
  sm: {
    track: {
      h: 2,
      borderRadius: '0.25rem'
    }
  },
  md: {
    track: {
      h: 4,
      borderRadius: '0.5rem'
    }
  },
  lg: {
    track: {
      h: 6,
      borderRadius: '0.75rem'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'green.200'
};
export default asMultiStyleConfig({
  parts,
  sizes,
  baseStyle,
  defaultProps
});